// Hashtag.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import { replace } from '../action/navigationAction.js';
import { LRUCache } from 'lru-cache';

import {
  HASHTAG_FEED_POST_VIDEO,
  HASHTAG_FEED_STORY,
} from '../RemoteConfigKeys.js';
import Hashtag from '../page/Hashtag.jsx';
import fetchHashtagSearch from '../action/fetchHashtagSearch.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getHashtagData from '../selector/getHashtagData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const ListType = {
  FLIX: 'flix',
  STORY: 'story',
};
const REMOTE_CONFIG_KEY_MAP = {
  [ListType.FLIX]: HASHTAG_FEED_POST_VIDEO,
  [ListType.STORY]: HASHTAG_FEED_STORY,
};

const cache = new LRUCache({ max: 256 });
const getListSelectPath = ({ feedNameWithQuery = '' } = {}) => {
  const key = `${feedNameWithQuery}`;
  let selectPath = cache.get(key);
  if (!selectPath) {
    selectPath = [
      'home',
      getReturnType({ feedName: feedNameWithQuery }),
      feedNameWithQuery,
    ];
    cache.set(key, selectPath);
  }
  return selectPath;
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { hashtag, type },
    },
  }
) => {
  const feedNameRemoteConfigKey = REMOTE_CONFIG_KEY_MAP[type];
  const hashtagFeedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{HASHTAG}',
    hashtag
  );
  const { feedNameWithQuery } = getSelectedQueryOptionObject(
    state,
    hashtagFeedName,
    getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
    getRemoteConfigData(
      state,
      `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
    )?.[0]
  );
  const listSelectPath = getListSelectPath({
    feedNameWithQuery,
  });
  const fetchStatus = getNetworkingSummary(state, [...listSelectPath, 1]);
  const messageIds = getListData(state, listSelectPath, 'itemIds');
  const nextPage = getListData(state, listSelectPath, 'nextPage');
  const isFirstMessageDetailFetched =
    'fetched' ===
    getNetworkingSummary(state, ['messages', messageIds?.[0], 'detail']).status;
  return {
    feedNameRemoteConfigKey,
    hashtagFeedName,
    feedNameWithQuery,
    hashtag,
    type,
    isAuthed: !!getMeData(state, 'id'),
    listSelectPath,
    messageIds,
    messageCount: getHashtagData(state, hashtag, 'messageCount'),
    nextPage,
    fetchStatus,
    isFirstMessageDetailFetched,
    isFirstPageFetching: getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetching'
    ),
    isNextPageFetching: getNetworkingData(
      state,
      [...listSelectPath, nextPage],
      'isFetching'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: args => dispatch(replace(args)),
    goBack: () => dispatch(goBack()),
    fetchHashtagSearch: data => dispatch(fetchHashtagSearch(data)),
    fetchMessageDetail: ({ id, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id, httpProxyHeaders })),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Hashtag);
